export default {
  docs: (state) => state.docs,
  docs_pending: (state) => state.docs_pending
}
